import Router from "vue-router";
import Vue from "vue";
import app from "@/main";
import authRoutes from "./routes/auth";
import frontRoutes from "./routes/front";
import otherRoutes from "./routes/other";

const routesMapData = Object.freeze( {
	auth: authRoutes,
	front: frontRoutes,
	other: otherRoutes
} );
const routesMap = [];

Object.keys( routesMapData ).forEach( routeGroupName => {
	const routeGroup = routesMapData[routeGroupName];

	if ( !routeGroup.hasOwnProperty( "meta" ) ) {
		routeGroup.meta = {};
	}

	if ( !routeGroup.meta.hasOwnProperty( "group" ) ) {
		routeGroup.meta.group = routeGroupName;
	}

	flattenChildren( routeGroup.children, routeGroup.meta );
} );

function flattenChildren( children, parentMeta ) {
	Object.keys( children ).forEach( routeName => {
		const route = children[routeName];

		route.name = routeName;

		route.meta = route.meta || {};
		route.meta.group = parentMeta.group;
		route.meta.auth = route.meta.hasOwnProperty( "auth" ) ? route.meta.auth : parentMeta.auth;
		route.meta.structure = parentMeta.structure ? JSON.parse( JSON.stringify( parentMeta.structure ) ) : [];
		route.meta.structure.push( routesMap.length );

		routesMap.push( route );

		if ( route.hasOwnProperty( "children" ) ) {
			flattenChildren( route.children, route.meta );

			delete route.children;
		}
	} );
}

const router = new Router( {
	mode: "history",
	routes: routesMap
} );

router.beforeEach( ( to, from, next ) => {
	router.canGoBack = Boolean( from.name );

	if ( app && app.$wait && to.name !== from.name ) {
		app.$wait.start( "router" );
	}

	next();
} );

router.afterEach( () => {
	if ( app && app.$wait ) {
		app.$wait.end( "router" );
	}
} );

Vue.router = router;

Vue.use( Router );

export default router;
